export default __webpack_public_path__ + "static/media/nickelodeon.97c5fdfa.png";